import { FormattedMessage } from 'react-intl';

import { ListItemButton, ListItemIcon, ListItemText, SxProps, Theme } from '@mui/material';

type HeaderMenuItemProps = Readonly<{
  icon: React.ReactElement;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  selected: boolean;
  titleId: string;
  sx?: SxProps<Theme>;
}>;

export default function HeaderMenuItem({ icon, onClick, selected, titleId, sx }: HeaderMenuItemProps) {
  return (
    <ListItemButton selected={selected} onClick={onClick} sx={sx}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={<FormattedMessage id={titleId} />} />
    </ListItemButton>
  );
}
